<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_showDetails">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['AFF']['AFFL']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showDetails = !bool_showDetails; resetPagination();">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" id="affl">
                                    <div>
                                        <CCol>
                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 20%;">{{this.getLanguage['MEM']['U']}}</th>
                                                        <th style="width: 20%;">{{this.getLanguage["AFF"]["RS"]}}</th>
                                                        <th style="width: 20%;">{{this.getLanguage['AFF']['AT']}}</th>
                                                        <th style="width: 20%;">{{this.getLanguage['AFF']['MAM']}}</th>
                                                        <th class="tableCtnRight" style="width: 20%;">
                                                        <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['EE_W']}}</span>
                                                        <span v-else>{{this.getLanguage['AFF']['EE']}}</span>
                                                    </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="kema-eft" @click="CheckingMember(obj_details.AGI,obj_details.RI)">
                                                            <span class="grid-line">
                                                                <div class="custom-tooltip">
                                                                    <span :style="getbgtooltip(obj_details)" @click.stop>{{obj_details.U}}</span>
                                                                    <span v-if="convertToBool(obj_details.TN)" class="custom-tooltiptext" :style="getbgtooltip(obj_details)">{{obj_details.TN}}</span>
                                                                </div>
                                                                <div class="custom-tooltip" v-if="obj_details.TW == 0">
                                                                    <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                                    <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                                                </div>
                                                                <div class="custom-tooltip" v-if="obj_details.HTWT">
                                                                    <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                                    <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                                                </div>
                                                                <div class="custom-tooltip" v-if="obj_details.RP">
                                                                    <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                                                    <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                                                </div>
                                                                <div class="float-right ml-1">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                                    </svg>
                                                                </div>
                                                            </span>
                                                        </td>
                                                        <td><span :style="`color:${obj_details.RS == '2' ? 'green':'red' }`">{{checkStatus(obj_details.RS)}}</span></td>
                                                        <td>{{ renderPayoutMethod(obj_details.AT) }}
                                                            <span class="grid-line">( {{ renderPayoutDuration(obj_details.IWLY) }} )</span>   
                                                        </td>
                                                        <td>{{ formatNumber(obj_details.MAM, 0) }}</td>
                                                        <td class="tableCtnRight">
                                                            <span v-if="obj_details.MAM <= obj_details.MTDADLM" :class="obj_details.ACA >= 0? 'positive-number': 'negative-number'">{{ formatNumber(obj_details.ACA, 2, obj_details.CS) }}</span>
                                                            <span v-else>{{ formatNumber(0, 2, obj_details.CS) }}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                    </div>
                                    <div>
                                        <CCol>
                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th class="tableCtnRight">{{this.getLanguage['AFF']['TNDLM']}}</th>
                                                        <th class="tableCtnRight">{{this.getLanguage['AFF']['TDLM']}}</th>
                                                        <th class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['MTDADLM_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['MTDADLM']}}</span>
                                                        </th>
                                                        <th class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['MTDDLM_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['MTDDLM']}}</span>
                                                        </th>
                                                        <th class="tableCtnRight">{{this.getLanguage['AFF']['TWLA']}}</th>
                                                        <th class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['MTDWLA_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['MTDWLA']}}</span>
                                                        </th>
                                                        <th class="tableCtnRight">{{this.getLanguage['AFF']['TTOA']}}</th>
                                                        <th class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['MTDTOA_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['MTDTOA']}}</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="tableCtnRight">
                                                            <span :class="obj_details.TTDLM >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(obj_details.TTDLM, 0) }}
                                                            </span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span :class="obj_details.TDLM >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(obj_details.TDLM, 0) }}
                                                            </span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span :class="obj_details.MTDADLM >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(obj_details.MTDADLM, 0) }}
                                                            </span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span :class="obj_details.MTDDLM >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(obj_details.MTDDLM, 0) }}
                                                            </span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span :class="obj_details.TWLA >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(obj_details.TWLA, 2, obj_details.CS) }}
                                                            </span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span :class="obj_details.MTDWLA >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(obj_details.MTDWLA, 2, obj_details.CS) }}
                                                            </span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span :class="obj_details.TTOA >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(obj_details.TTOA, 2, obj_details.CS) }}
                                                            </span>
                                                        </td>
                                                        <td class="tableCtnRight">
                                                            <span v-if="obj_details.MAM <= obj_details.MTDADLM">
                                                                <span :class="obj_details.MTDTOA >= 0? 'positive-number': 'negative-number'">
                                                                    {{ formatNumber(obj_details.MTDTOA, 2, obj_details.CS) }}
                                                                </span>
                                                            </span>
                                                            <span v-else>{{ formatNumber(0, 2, obj_details.CS) }}</span>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                    </div>
                                    <div class='with_page'>
                                        <CCol>
                                            <header class="table-header">
                                                <strong>{{obj_details.U}}'s {{this.getLanguage["AFF"]["AFDML"]}}</strong>
                                                <div class="pageBtn">
                                                    <button @click="ctrPopUpPage(+int_PopUpPage - 1)">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_PopUpPage"
                                                           type="number"
                                                           v-shortkey.avoid
                                                           @keyup="ctrPopUpPage(+int_PopUpPage,0)" />
                                                    <span class="tableItemCount">/ {{int_PopUpTP}}</span>
                                                    <button @click="ctrPopUpPage(+int_PopUpPage + 1)">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                            </header>
                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                                        <th>{{this.getLanguage["GL"]["ACT"]}}</th>
                                                        <th style="padding-right:100px">{{this.getLanguage['MEM']['U']}}</th>
                                                        <th v-if="obj_details.IMT==1">{{this.getLanguage["AFF"]["T"]}}</th>
                                                        <th>{{this.getLanguage['AFF']['JD']}}</th>
                                                        <th v-if="obj_details.AT!=2" class="tableCtnRight">{{this.getLanguage['AFF']['TWLA']}}</th>
                                                        <th v-if="obj_details.AT!=2" class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['MTDWLA_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['MTDWLA']}}</span>
                                                        </th>
                                                        <th v-if="obj_details.AT==2" class="tableCtnRight">{{this.getLanguage['AFF']['TTOA']}}</th>
                                                        <th v-if="obj_details.AT==2" class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['MTDTOA_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['MTDTOA']}}</span>
                                                        </th>
                                                        <th class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['EE_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['EE']}}</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(data,index) in arry_details" :class="data.AS == 1? 'blacklist-row': ''">
                                                        <td>{{ CountPopUpItem(index+1) }}</td>
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <div class="custom-tooltip">
                                                                    <i class="cil-description" @click="showPCTDetails(data)"></i> <!--here View -->
                                                                    <span class="custom-tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                                                </div>
                                                            </span>

                                                        </td>

                                                        <td class="kema-eft" @click="CheckingMember(data.AGI,data.MI)">
                                                            <span class="grid-line">
                                                                <div class="custom-tooltip">
                                                                    <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                                                    <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                                                </div>
                                                                <div class="custom-tooltip" v-if="data.TW == 0">
                                                                    <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                                    <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                                                </div>
                                                                <div class="custom-tooltip" v-if="data.HTWT">
                                                                    <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                                    <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                                                </div>
                                                                <div class="custom-tooltip" v-if="data.RP">
                                                                    <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                                                    <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                                                </div>
                                                                <div class="float-right ml-1">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                                    </svg>
                                                                </div>
                                                            </span>
                                                            <span v-if="obj_details.IMT==1" class="saggroupname">{{ data.RN }}</span>
                                                            <span v-if="data.AS==1" class="grid-line rejectReason">{{renderDisqualifyReason(data.DAR)}}</span>
                                                        </td>
                                                        <td v-if="obj_details.IMT==1">{{ data.LVL }}</td>
                                                        <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                        <td v-if="obj_details.AT!=2" class="tableCtnRight">
                                                            <span :class="data.TWLA >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(data.TWLA, 2, data.CS) }}
                                                            </span>
                                                        </td>
                                                        <td v-if="obj_details.AT!=2" class="tableCtnRight">
                                                            <span :class="data.MTDWLA >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(data.MTDWLA, 2, data.CS) }}
                                                            </span>
                                                        </td>
                                                        <td v-if="obj_details.AT==2" class="tableCtnRight">
                                                            <span :class="data.TTOA >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(data.TTOA, 2, data.CS) }}
                                                            </span>
                                                        </td>
                                                        <td v-if="obj_details.AT==2" class="tableCtnRight">
                                                            <span :class="data.MTDTOA >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(data.MTDTOA, 2, data.CS) }}
                                                            </span>
                                                        </td>
                                                        <td class="tableCtnRight">

                                                            <span :class="data.C >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(data.C, 3, data.CS) }}
                                                            </span>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_showPCTDetails">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">
                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['EE_W']}}</span>
                                            <span v-else>{{this.getLanguage['AFF']['EE']}}</span>
                                            -  {{ formatNumber(this.obj_pctdetails.C, 3, this.obj_pctdetails.CS) }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showPCTDetails = !bool_showPCTDetails;">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" id="affl">
                                    <div class='with_page'>
                                        <CCol>

                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                                        <th style="padding-right:100px">{{this.getLanguage['MEM']['U']}}</th>
                                                        <th>{{this.getLanguage["GAME"]["GC"]}}</th>
                                                        <th v-if="obj_details.AT!=2" class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['MTDWLA_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['MTDWLA']}}</span>
                                                        </th>
                                                        <th v-if="obj_details.AT==2" class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['MTDTOA_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['MTDTOA']}}</span>
                                                        </th>
                                                        <th>{{this.getLanguage["AFF"]["CPCT"]}}</th>
                                                        <th class="tableCtnRight">
                                                            <span v-if="obj_details.IWLY==1">{{this.getLanguage['AFF']['EE_W']}}</span>
                                                            <span v-else>{{this.getLanguage['AFF']['EE']}}</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(data,index) in arry_pctdetails" :class="data.AS == 1? 'blacklist-row': ''">
                                                        <td>{{ CountPopUpItem(index+1) }}</td>
                                                        <td class="kema-eft">
                                                            <span class="grid-line">

                                                                <div class="custom-tooltip">
                                                                    <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>

                                                                    <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                                                </div>

                                                            </span>
                                                            <span v-if="obj_pctdetails.IMT==1" class="saggroupname">{{ data.RN }}</span>
                                                            <span v-if="data.AS==1" class="grid-line rejectReason">{{renderDisqualifyReason(data.DAR)}}</span>
                                                        </td>
                                                        <td>{{ data.CN }}</td>

                                                        <td v-if="obj_details.AT!=2" class="tableCtnRight">
                                                            <span :class="data.MTDWLA >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(data.MTDWLA, 2, data.CS) }}
                                                            </span>
                                                        </td>

                                                        <td v-if="obj_details.AT==2" class="tableCtnRight">
                                                            <span :class="data.MTDTOA >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(data.MTDTOA, 2, data.CS) }}
                                                            </span>
                                                        </td>
                                                        <td class="tableCtnRight">{{ data.CPCT }}</td>
                                                        <td class="tableCtnRight">

                                                            <span :class="data.C >= 0? 'positive-number': 'negative-number'">
                                                                {{ formatNumber(data.C, 3, data.CS) }}
                                                            </span>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["NO"]}}
                                            </template>
                                            <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.view)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'RS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AFF']['RS']}}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["AFF"]["BN"]}}
                                                <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TNDM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AFF']['TNDLM']}}
                                            </template>
                                            <template v-else-if="header == 'TDM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AFF']['TDLM']}}
                                            </template>
                                            <template v-else-if="header == 'MTDADM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AFF']['MTDADLM_MW']}}
                                            </template>
                                            <template v-else-if="header == 'MTDDM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AFF']['MTDDLM_MW']}}
                                            </template>
                                            <template v-else-if="header == 'TDWL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AFF']['TWLA']}}
                                            </template>
                                            <template v-else-if="header == 'MTDWL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AFF']['MTDWLA_MW']}}
                                            </template>
                                            <template v-else-if="header == 'TDT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AFF']['TTOA']}}
                                            </template>
                                            <template v-else-if="header == 'MTDDT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AFF']['MTDTOA_MW']}}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["AFFL"]}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="searchExcludeSubAgent" id="searchExcludeSubAgent" />
                                        <label class="searchLabel ml-1" for="searchExcludeSubAgent">{{getLanguage["GL"]["ODA"]}}</label>
                                    </div>
                                </div>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :cacheOptions="false"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="str_FV[1].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AFF"]["AT"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_pm"
                                            :placeholder="this.utilGetDDLanguage('AFF.AT')"
                                            v-model="str_FV[2].FV"
                                            :disable-branch-nodes="true"
                                            :default-expand-level="1"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AFF"]["C"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_fullcurrency"
                                            :placeholder="this.utilGetDDLanguage('AFF.C')"
                                            v-model="str_FV[3].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['AFF']['AFFL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.view)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['RS']}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["BN"]}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TNDM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['TNDLM']}}
                                    </template>
                                    <template v-else-if="header == 'TDM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['TDLM']}}
                                    </template>
                                    <template v-else-if="header == 'MTDADM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['MTDADLM_MW']}}
                                    </template>
                                    <template v-else-if="header == 'MTDDM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['MTDDLM_MW']}}
                                    </template>
                                    <template v-else-if="header == 'TDWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['TWLA']}}
                                    </template>
                                    <template v-else-if="header == 'MTDWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['MTDWLA_MW']}}
                                    </template>
                                    <template v-else-if="header == 'TDT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['TTOA']}}
                                    </template>
                                    <template v-else-if="header == 'MTDDT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['MTDTOA_MW']}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.view)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['RS']}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["BN"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TNDM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['TNDLM']}}
                                    </template>
                                    <template v-else-if="header == 'TDM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['TDLM']}}
                                    </template>
                                    <template v-else-if="header == 'MTDADM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['MTDADLM_MW']}}
                                    </template>
                                    <template v-else-if="header == 'MTDDM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['MTDDLM_MW']}}
                                    </template>
                                    <template v-else-if="header == 'TDWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['TWLA']}}
                                    </template>
                                    <template v-else-if="header == 'MTDWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['MTDWLA_MW']}}
                                    </template>
                                    <template v-else-if="header == 'TDT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['TTOA']}}
                                    </template>
                                    <template v-else-if="header == 'MTDDT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AFF']['MTDTOA_MW']}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_adl.length == 0">{{getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_adl">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.view))">
                                    <span id="actionBtnCol" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <span v-if="checkModuleAccess2(constAccessType.view)" class="custom-tooltip">
                                            <i class="cil-description" @click="showDetails(data)"></i> <!--here View -->
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                        </span>
                                    </span>
                                    <span id="actionBtnCol" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <span v-if="checkModuleAccess2(constAccessType.view)" class="custom-tooltip">
                                            <i class="cil-description"></i> <!--here View -->
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'RS'">
                                    <span :style="`color:${data.RS == '2' ? 'green':'red' }`">{{checkStatus(data.RS)}}</span>
                                </template>
                                <template v-else-if="header == 'BN'">
                                    <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                    <span class="saggroupname" v-if="data.SAGPC != ''">{{ data.SAGGN }} ({{ data.SAGPC }})</span>
                                </template>
                                <template v-else-if="header == 'U'">
                                    <span class="grid-line" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AGI,data.RI)">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span class="grid-line" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)">{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'TNDM'">
                                    {{ formatNumber(data.TTDLM, 0) }}
                                </template>
                                <template v-else-if="header == 'TDM'">
                                    {{ formatNumber(data.TDLM, 0) }}
                                </template>
                                <template v-else-if="header == 'MTDADM'">
                                    {{ formatNumber(data.MTDADLM, 0) }}
                                </template>
                                <template v-else-if="header == 'MTDDM'">
                                    {{ formatNumber(data.MTDDLM, 0) }}
                                </template>
                                <template v-else-if="header == 'TDWL'">
                                    {{ formatNumber(data.TWLA, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'MTDWL'">
                                    {{ formatNumber(data.MTDWLA, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'TDT'">
                                    {{ formatNumber(data.TTOA, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'MTDDT'">
                                    {{ formatNumber(data.MTDTOA, 2, data.CS) }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, constDisqualifyMemberAff, loadingFullScreen } from '@/modules/Constant.js'
    import $ from 'jquery'
    import Vue from 'vue'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Sortable,
            draggable
        },
        data() {
            return {
                bool_showDetails: false,
                bool_showPCTDetails: false,
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                int_PopUpTI: 0,  //PopUp Total Items
                int_PopUpRC: 100, //PopUp Row Count
                int_PopUpPage: 1,//PopUp current Page
                int_PopUpIC: 1, // PopUp Item Count
                int_PopUpTP: 1, //PopUp Total Page
                temp_data: null,
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "RI" }, { F: "AT_csv", FA: true }, { F: "CI_csv", FA: true }], //Filter Value
                arry_adl: [], //affiliate details list
                dd_agentgroup: [],//agent group option
                dd_pm: [],
                ddMemberList: [],
                dd_fullcurrency: [],
                obj_details: {},
                arry_details: [],
                obj_pctdetails: {},
                arry_pctdetails: [],
                dd_AffiliatePayoutOption: [],
                constAccessType: constAccessType,
                defaultReportHeaders: ['NO', 'ACT', 'RS', 'BN', 'U', 'TNDM', 'TDM', 'MTDADM', 'MTDDM', 'TDWL', 'MTDWL', 'TDT', 'MTDDT'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                searchExcludeSubAgent: false
            }
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'AFF';
            this.$parent.showActiveMenu = 'AFF.AFFL';
       
            this.getAffiliateReportList();
            this.getAgentGroup();
            this.getPMList();
            this.getCurrencyList();
            this.getPayoutTypeList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getAffiliateReportList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getAffiliateReportList();
            },
            ctrPopUpPage(newPage, inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_PopUpPage = Math.max(1, Math.min(newPage, this.int_PopUpTP));
                }
                else {
                    this.int_PopUpPage = (newPage > this.int_PopUpTP) ? 1 : (newPage < 1) ? this.int_PopUpTP : newPage;
                }
                this.int_PopUpIC = this.int_PopUpPage;
                if (this.temp_data != null) {
                    this.showDetails(this.temp_data);
                }
            },
            CountPopUpItem(value) {
                if (this.int_PopUpIC != 1) {
                    return value + ((this.int_PopUpIC - 1) * this.int_PopUpRC);
                } else {
                    return value;
                }
            },
            resetPagination() {
                this.temp_data = null;
                this.int_PopUpTI = 0;       //PopUp Total Items
                this.int_PopUpPage = 1;     //PopUp current Page
                this.int_PopUpIC = 1;       // PopUp Item Count
                this.int_PopUpTP = 1;       //PopUp Total Page
            },
            showDetails(data) {
                this.temp_data = data;
                this.arry_details = [];
                this.bool_fullLoading = true;
                this.obj_details = Object.assign(this.obj_details, data);
                var that = this;
                var path = this.getListingParamQuery(this.int_PopUpPage, this.int_PopUpRC, "MI", true);
                //path += ("&f[RI]=" + data.RI);
                path += ("&f[MNI]=" + data.RI);              
                //if (data.IMT != 1) {
                //    path += ("&f[LVL]=1");
                //}
                
                this.getDataApi(`/api/aff/llad?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.bool_showDetails = true;
                            that.setPopUpReportList(d.D)
                        }
                    });
            },
            showPCTDetails(data) {
                this.temp_data = data;
                this.arry_pctdetails = [];
                this.bool_fullLoading = true;
                this.obj_pctdetails = Object.assign(this.obj_pctdetails, data);
                var that = this;
                var path = this.getListingParamQuery(this.int_PopUpPage, this.int_PopUpRC, "MI", true);
                //path += ("&f[RI]=" + data.RI);
                path += ("&f[MNI]=" + data.MNI);
                path += ("&f[MI]=" + data.MI);
               
                //if (data.IMT != 1) {
                //    path += ("&f[LVL]=1");
                //}

                this.getDataApi(`/api/aff/pct?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.bool_showPCTDetails = true;
                            that.setPopUpPCTReportList(d.D)
                        }
                    });
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('AFFL', 'AFF', type);
            },
            getPMList() {
                this.dd_pm = [
                    {
                        id: -1,
                        label: this.getLanguage['AFF']['CAT'] + ' 1',
                        children: [
                            {
                                id: '1',
                                label: this.getLanguage['AFF']['PM1']
                            },
                            {
                                id: '2',
                                label: this.getLanguage['AFF']['PM2']
                            },
                            {
                                id: '4',
                                label: this.getLanguage['AFF']['PM4']
                            }
                        ]
                    },
                    {
                        id: '-2',
                        label: this.getLanguage['AFF']['CAT'] + ' 2',
                        children: [
                            {
                                id: '3',
                                label: this.getLanguage['AFF']['PM3']
                            }
                        ]
                    }
                ];
            },
            getPayoutTypeList() {
                this.dd_payoutType = [{ id: '0', label: this.getLanguage['AFF']['PT0'] }, { id: '1', label: this.getLanguage['AFF']['PT1'] },];
                this.dd_AffiliatePayoutOption = [{ id: 0, label: this.getLanguage['PM']['MLY'] }, { id: 1, label: this.getLanguage['PM']['WLY'] }];
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }

                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_fullcurrency = d.dropdownlist;
                        }
                    });
            },
            getCurrentMonth() {
                var month = moment(new Date()).format('MMMM');
                return month;
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });
            },
            checkStatus(RS) {
                var a = this.$parent.checkStatus(RS);
                if (a) {
                    return this.getLanguage["GL"]["AC"];
                } else {
                    return this.getLanguage["GL"]["IAC"];
                }
            },
            CheckingMember(agi, mi) {
                if (mi != null && mi != 0 && mi != "") {
                    let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                    window.open(routeData.href, '_blank');
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.str_FV[0].FV}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                        this.str_FV[0].FV = this.searchPAgi;
                    } else {
                        this.searchPAgi = 0;
                    }
                } else {
                    this.searchPAgi = 0;
                    this.str_FV[0].FV = null;
                }
                this.str_FV[3].FV = null;
                this.dd_fullcurrency = null;
                this.getCurrencyList();
            },
            getAffiliateReportList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };
                path += "&f[EXSAG]=" + this.searchExcludeSubAgent;
                this.getDataApi(`/api/aff/ll?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setAffiliateReportList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setPopUpReportList(data) {
                this.arry_details = data.Items;
                this.int_PopUpTP = Math.max(data.TotalPages, 1);
                this.int_PopUpTI = data.TotalItems;
            },
            setPopUpPCTReportList(data) {
                this.arry_pctdetails = data.Items;
            },
            setAffiliateReportList(data) {
                if (data.Items == null) {
                    this.arry_adl = [];
                } else {
                    this.arry_adl = data.Items;
                }
                this.int_TP = Math.max(data.TotalPages, 1);
                this.int_TI = data.TotalItems;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                } else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getAffiliateReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            renderPayoutMethod(value) {
                var pm = "-";
                if (value != 0) {
                    if (this.dd_pm.length > 0) {
                        for (var i = 0; i < this.dd_pm.length; i++) {
                            for (var j = 0; j < this.dd_pm[i].children.length; j++) {
                                if (this.dd_pm[i].children[j].id == value) {
                                    pm = this.dd_pm[i].label + ' - ' + this.dd_pm[i].children[j].label;
                                    break;
                                }
                            }
                        }
                    }
                    else {
                        this.getPMList();
                    }
                }
                return pm;
            },
            renderPayoutDuration(value) {
                if (value != null) {
                    return this.dd_AffiliatePayoutOption[value].label;
                }
                else {
                    return '-';
                }
            },
            renderDisqualifyReason(rejectReason) {
                const found = constDisqualifyMemberAff.some(el => el.id === rejectReason);

                if (found) {
                    for (var d of constDisqualifyMemberAff) {
                        if (d.id == rejectReason) {
                            rejectReason = d.label;
                        }
                    }
                }

                return rejectReason;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            renderClassName(header, data) {
                if (header == 'U') {
                    return "kema-eft";
                }else if (header == 'TNDM' || header == 'TDM' || header == 'MTDADM' || header == 'MTDDM' || header == 'TDWL' || header == 'MTDWL' || header == 'TDT' || header == 'MTDDT') {
                    return "tableCtnRight";
                } 
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
        },
        watch: {
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/AffiliateList`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                // hide columns for unauthorized access users
                                if (!that.checkModuleAccess2(constAccessType.view)) {
                                    that.removeDefaultColumn('ACT')
                                    that.removeColumn('ACT')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/AffiliateList/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        }

    }

</script>

<style>
    #affl .custom-table-inPopUp th {
        width: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Affiliate/AffiliateList.vue